import { withPluginApi } from "discourse/lib/plugin-api";

const PLUGIN_ID = "hosted-site";
const THEME_RESTRICTED_TIERS = ["free", "basic", "starter"];

function initialize(api) {
  if (!api.getCurrentUser()?.admin) {
    return;
  }

  api.modifyClass("route:admin-customize.index", {
    pluginId: PLUGIN_ID,

    beforeModel() {
      if (!this.currentUser.admin) {
        return this.router.replaceWith("adminWatchedWords");
      }

      if (!this.siteSettings.hide_admin_customize_themes) {
        return this.router.replaceWith("adminCustomizeThemes");
      }

      if (this.siteSettings.hide_admin_customize_colors) {
        return this.router.replaceWith("adminSiteText");
      }

      return this.router.replaceWith("adminConfig.colorPalettes");
    },
  });

  api.modifyClass("route:admin-customize-themes.show", {
    pluginId: PLUGIN_ID,

    afterModel(model, transition) {
      if (THEME_RESTRICTED_TIERS.includes(this.siteSettings.discourse_tier)) {
        transition.abort();
        const route = model.component
          ? "adminConfig.customize.components"
          : "adminConfig.customize.themes";
        this.router.transitionTo(route);
      }
    },
  });
}

export default {
  name: "extend-admin-customize",
  initialize(container) {
    withPluginApi((api) => initialize(api, container));
  },
};
